<script setup lang="ts">
import { fetchBooths } from '~/lib/booth';

const name = "観光学部展"

definePageMeta({
  title: "展示・模擬店 - 観光学部展"
})

// const { data: booths } = useAsyncData(
//   `booths-${name}`,
//   () => fetchBooths(name),
//   { server: true, lazy: false }
// )
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-[8px] my-4 h-[calc(100svh-64px)] md:h-[auto]">
    <div class="flex-grow md:flex-grow-0 mb-4 overflow-x-scroll md:overflow-x-auto max-w-full ">
      <NuxtImg class="max-h-full max-w-[none] md:max-h-none md:w-full" format="webp" src="/img/kenkyujo.jpg" decoding="async"
        loading="lazy" />
    </div>

    <div class="mb-4">
      <NuxtLink class="btn btn-primary" to="/booth">
        前のページに戻る
      </NuxtLink>
    </div>
  </article>
</template>